export const endPoints = {
  novaAI: {
    chat: `/api/chat`,
    chatStream: `/api/chat/stream`,
    transcribe: `/api/stt/transcribe`,
    voice: `/api/voice`,
  },
  auth: {
    validate: `/api/auth/validate`,
    getUserDetails: `/api/users/details`,
    agencyValidation: `/api/LookUps/validate-agency-name`,
    technicianPermissions: (roleId: number) => `/api/technicians/${roleId}/permissions`,
  },
  header: {
    indirectActivity: `api/technicians/indirect-activity`,
    saveIndirectActivity: (techId: number) =>
      `/api/technicians/${techId}/indirect-activity`,
  },
  shopHomePage: {
    getTechnicians: `/api/technicians?`,
    getShopsList: `/api/shops`,
    checkPinRequirement: `/api/settings/IsPinRequired`,
  },
  pinAuthentication: {
    verifyPin: `/api/technicians/`,
    setPin: (techId: string) => `/api/technicians/${techId}/set-pin`,
  },
  dashboard: {
    getWorkOrders: `/api/WorkOrderRepairs/technician?`,
    getTechnicianDetails: `/api/technicians/`,
    filterWorkOrders: `/api/WorkOrderRepairs/search`,
    beginShift: `/shift/begin`,
    endShift: (
      techId: number,
      IsLaborOvertimeCheckRequired: boolean,
      isIndirectOvertimeCheckRequired: boolean,
      userTimeZone: string
    ) =>
      `/api/v1/Shifts/${techId}/end?isLaborOvertimeCheckRequired=${IsLaborOvertimeCheckRequired}&isIndirectOvertimeCheckRequired=${isIndirectOvertimeCheckRequired}&userTimeZone=${userTimeZone}`,
    completedRepairsCount: (technicianId: number) =>
      `/api/WorkOrderRepairs/${technicianId}/CompletedRepairsCount?`,
    shiftStatus: (technicianId: number) =>
      `/api/technicians/${technicianId}/status-indicator`,
    allAvailablePartsStatus: `/api/parts/getpartsrequestedstatus`,
    requestedParts: `/api/parts/requested`,
    allRepairPriorities: `/api/LookUps/priorities`,
    partRequestCounts: (technicianId: number) =>
      `/api/parts/part-request-counts?technicianId=${technicianId}`,
    getLastWOList: (technicianId: number) =>
      `/api/WorkOrderRepairs/last-workorder?technicianId=${technicianId}`,
  },
  repairDetails: {
    tasks: `/api/task/`,
    repairData: '/api/WorkOrderRepairs/',
    repairParts: (repairId: number) => `/api/parts/repair/${repairId}?`,
    configuredRepairParts: `/api/PartList/parts?`,
    notes: `/api/workordernotes?repairId=`,
    updateTask: `/api/task/`,
    workOrderStatus: `/api/LookUps/WorkOrderStatus`,
    addNewNote: `/api/workordernotes`,
    getPartsList: `/api/parts/search?`,
    updateWorkOrderStatus: (woId: number, selectedReason: string) =>
      `/api/workorders/${woId}/status/${selectedReason}`,
    changeWOStatus: `/api/workorders/status`,
    confirmWOStatus: `/api/workorders/confirm-complete`,
    repairReasonStatus: `/api/LookUps/RepairReasons`,
    updateRepairReasonStatus: (repairId: number, selectedReason: number) =>
      `/api/WorkOrderRepairs/${repairId}/Reason/${selectedReason}`,
    submitParts: `/api/PartList`,
    beginRepair: (repairId: number) =>
      `/api/WorkOrderRepairs/${repairId}/begin`,
    repairHours: (repairId: number, technicianId: number) =>
      `/api/WorkOrderRepairs/${repairId}/repair-hours?technicianId=${technicianId}`,
    endRepair: `/api/WorkOrderRepairs/repair/end`,
    pauseRepair: (technicianId: number) =>
      `/api/technicians/${technicianId}/pause-repair`,
    partsHistory: (repairId: string) => `/api/parts/repair/${repairId}`,
    partsHistoryStatus: `api/parts/getpartsrequestedstatus`,
    getMessages: `api/parts/messages?`,
    getMessageById: (messageId: number) => `api/parts/messages/${messageId}`,
    updateMessageById: `api/parts/messages`,
    deleteNote: (noteId: number, isRepairNote: boolean, technicianId: number) =>
      `/api/workordernotes/${noteId}/${isRepairNote}/${technicianId}`,
    editNote: `/api/workordernotes/edit`,
    addNewAssetAttachment: (assetId: string | number) => `/api/assets/${assetId}/attachments`,
    updateAssetAttachment: (workOrderId: string | number, attachmentId: string | number) => `/api/assets/${workOrderId}/attachments/${attachmentId}`,
    deleteAssetAttachment: (assetId: string | number, attachmentId: string | number, technicianId: number) => `/api/assets/${assetId}/attachments/${attachmentId}/${technicianId}`,
    addNewWorkOrderAttachment: (assetId: string | number) => `/api/workorders/${assetId}/attachments`,
    updateWorkOrderAttachment: (workOrderId: string | number, attachmentId: string | number) => `/api/workorders/${workOrderId}/attachments/${attachmentId}`,
    deleteWorkOrderAttachment: (workOrderId: string | number, attachmentId: string | number, technicianId: number) => `/api/workorders/${workOrderId}/attachments/${attachmentId}/${technicianId}`,
    getAttachmentCategories: `/api/attachments/categories`,
    getAssetAttachments: (assetId: string | number, workOrderId: string | number) =>
      `/api/assets/${assetId}/workorders/${workOrderId}/attachments`,
    getAssetAttachmentById: (
      assetId: string | number,
      attachmentId: string | number,
    ) => `/api/assets/${assetId}/attachments/${attachmentId}`,
    getWorkOrderAttachmentById: (
      workOrderId: string | number,
      attachmentId: string | number,
    ) => `/api/workorders/${workOrderId}/attachments/${attachmentId}`,
    getAssetAttachmentFile: (
      assetId: string | number,
      attachmentId: string | number,
    ) => `/api/assets/${assetId}/attachments/${attachmentId}/file`,
    getWorkOrderAttachmentFile: (
      woId: string | number,
      attachmentId: string | number,
    ) => `/api/workorders/${woId}/attachments/${attachmentId}/download`,
    getMeters: (woId: number) => `/api/meters/${woId}/meters`,
    getMeterDetail: (meterTransactionId: number) =>
      `/api/meters/${meterTransactionId}/detail`,
    updateMeter: `/api/meters`,
    requestAuthorization: `/api/workorders/request-authorization`,
  },
  repairHistory: {
    repairHistorySearch: `/api/WorkOrderRepairs/repair-history/search`,
    repairHistoryWODetails: `/api/WorkOrderRepairs/RepairHistoryWOdetails`,
    repairHistoryWORepairList: `/api/WorkOrderRepairs/RepairHistoryWORepairlist`,
    repairHistoryWOPartList: `/api/WorkOrderRepairs/RepairHistoryWOPartlist`,
    repairHistoryWOSubletList: `/api/WorkOrderRepairs/RepairHistoryWOSubletlist`,
    repairHistoryWONoteList: `/api/WorkOrderRepairs/RepairHistoryWONotelist`,
    workOrderNoteDetail: (noteId: number) => `/api/workordernotes/${noteId}`,
    assetSearch: `/api/assets/search`,
    repairGroupsComponents: `/api/LookUps/repair-groups-components`,
    similarModels: (assetId: number) =>
      `/api/LookUps/assets/${assetId}/similar-models`,
  },
  alerts: {
    getAlertButtonState: (assetId: number) =>
      `/api/alerts/asset/${assetId}/button-state`,
    getAssetAlerts: (assetId: number) =>
      `/api/alerts/asset/${assetId}`,
    getLatestRepairAlert: (repairId: number) =>
      `/api/alerts/repair/${repairId}/alert`,
  },
  help: {
    categories: `/api/HelpArticles/categories`,
    getArticles: `/api/HelpArticles?`,
    videos: `/api/HelpArticles/videos`,
  },
  createFlow: {
    getOrganizations: (createdUserId: number) =>
      `/api/assets/user-organizations/${createdUserId}`,
    validateAsset: (assetNumber: string | number, assetOrganization: string) =>
      `/api/assets/verifyasset?assetNumber=${encodeURIComponent(assetNumber)}&assetOrganization=${encodeURIComponent(assetOrganization)}`,
    getPmSaDetails: (
      assetId: number,
      userId: number | string,
      assetStatus: string,
      assetDepartment: string,
    ) =>
      `/api/Assets/${assetId}/pm-sa-details?userId=${userId}&assetStatus=${assetStatus}&assetDepartment=${assetDepartment}`,
    getAssetDetails: `/api/workOrder/assetDetails`,
    getOpenWorkOrders: `/api/workOrder/openWorkOrders`,
    getReplacementInfo: `/api/workOrder/replacement`,
    getPreventiveMaintenance: `/api/workOrder/preventiveMaintenance`,
    getScheduledActions: `/api/workOrder/scheduledActions`,
    getContacts: `/api/workOrder/contacts`,
    getWorkOrderMaintShops: `/api/LookUps/maint-shops`,
    getWorkOrderStatuses: `/api/LookUps/work-order-statuses`,
    getWorkOrderDepartments: `/api/LookUps/departments`,
    getWorkOrderBillCodes: `/api/LookUps/bill-codes`,
    getWorkOrderFormContacts: (assetId: number) =>
      `/api/LookUps/assets/${assetId}/contacts`,
    getAssetMeters: (assetId: number) =>
      `api/meters/asset-meters?assetId=${assetId}`,
    getWorkOrderPriorities: `/api/workOrder/priorities`,
    getRepairCreationOverduePM: (assetId: number) =>
      `/api/workOrder/repair/overdue-pm?assetId=${assetId}`,
    getRepairCreationScheduledActions: (assetId: number) =>
      `/api/workOrder/repair/scheduled-actions-past-due?assetId=${assetId}`,
    getRepairFormOptions: (assetId: number, documentId: number) =>
      `/api/LookUps/repair-form-options?assetId=${assetId}&documentId=${documentId}`,
    getRepairReasons: `/api/workOrder/repair/reasons`,
    getRepairSchedules: `/api/workOrder/repair/schedules`,
    getRepairMaintenanceShops: `/api/workOrder/repair/maintenance-shops`,
    // getRepairActions: `/api/workOrder/repair/actions`,
    // getRepairGroups: `/api/workOrder/repair/groups`,
    // getRepairComponents: `/api/workOrder/repair/components`,
    getRepairShifts: `/api/workOrder/repair/shifts`,
    getRepairPriorities: `/api/workOrder/repair/priorities`,
    getWorkOrderSuccessDetails: `/api/workOrder/success`,
    getRepairFlowShops: `/api/repairFlow/shops`,
    getWorkOrdersForRepairFlow: `/api/workorders/search`,
    getWorkOrderWithRepairs: (documentId: number) =>
      `/api/WorkOrderRepairs/${documentId}/repairs`,
    getWarranties: (assetId: number) =>
      `/api/assets/${assetId}/warranties`,
    repairFormControlSync: `/api/LookUps/repair-form/control-sync`,
    getLaborStandardHours: `/api/LookUps/labor-standard-hours`,
    getAverageLabourHours: `/api/LookUps/average-labour-hours`,
    getRepairAGCGrid: `/api/lookups/repair-form/agc-grid`,
    createWorkOrder: `/api/workorders`,
    updateWorkOrderBarcode: (documentId: number) =>
      `/api/workorders/${documentId}`,
    createRepair: `/api/WorkOrderRepairs/Create`,
  },
};